import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../../app/store'
import fetchAPI from '../../../common/fetchAPI'
import { ExpensePolicyLockingExpenseStateClass } from './interfaces/expensePolicyLockingExpenseStateClass';
const initialState: ExpensePolicyLockingExpenseStateClass = {
    isLoading: false,
    status: 'idle',
    expensePolicyLockingExpenseDetail: [],
    selectedRecord: {},
    isReload : false
}
interface IThunkApi {
    state: {
        expensePolicyLockingExpenses: ExpensePolicyLockingExpenseStateClass;
    },
}

    export const getDataForlockingExpenseByAccountExpensePolicyIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'expensePolicyLockingExpenses/getDataForlockingExpenseByAccountExpensePolicyId',
        async (arg, thunkApi) => {
            const {AccountExpensePolicyId} = arg;
            const response = await fetchAPI('api/ExpensePolicies/GetPolicyDetails/'+ arg, 'Get', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

    export const getDataLockExpensesForEditByAccountExpensePolicyIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'expensePolicyLockingExpenses/getDataLockExpensesForEditByAccountExpensePolicyId',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/ExpensePolicies/GetLockExpensesDataByAccountExpensePolicyId/' + arg , 'Get', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

    export const updateLockingExpensesByAccountExpensePolicyIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'expensePolicy/updateLockingExpensesByAccountExpensePolicyId',
        async (arg, thunkApi) => {
            const { AccountExpensePolicyId, ...argWithoutId } = arg;
            const response = await fetchAPI('api/ExpensePolicies/UpdateLockExpenseEntries/' + AccountExpensePolicyId, 'POST', argWithoutId, true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )


export const expensePolicyLockingExpenseSlice = createSlice({
    name: 'expensePolicyLockingExpenses',
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {};
        }
    },
    extraReducers: (builder) => {
        builder
           
       
            .addCase(getDataForlockingExpenseByAccountExpensePolicyIdAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(getDataForlockingExpenseByAccountExpensePolicyIdAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isLoading = false;
                state.expensePolicyLockingExpenseDetail = payload.data;
                state.isReload = false;
                state.selectedRecord = payload.data[0];
                
            })
            .addCase(getDataForlockingExpenseByAccountExpensePolicyIdAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            }) 


            .addCase(getDataLockExpensesForEditByAccountExpensePolicyIdAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(getDataLockExpensesForEditByAccountExpensePolicyIdAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isLoading = false;
                state.expensePolicyLockingExpenseDetail = payload.data;
                state.isReload = false;
            })
            .addCase(getDataLockExpensesForEditByAccountExpensePolicyIdAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            }) 

            .addCase(updateLockingExpensesByAccountExpensePolicyIdAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

                

            })
            .addCase(updateLockingExpensesByAccountExpensePolicyIdAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;

            })
            .addCase(updateLockingExpensesByAccountExpensePolicyIdAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })


    }
})
export const {
    resetSelectedRecordObjectInState
} = expensePolicyLockingExpenseSlice.actions
 export const expensePolicyLockingExpenseStateClass = (state: RootState) => state.expensePolicyLockingExpenses
 export default expensePolicyLockingExpenseSlice.reducer